import LegalLinks from "../../components/legal-links";
import Logos from "../../components/logos";
import css from './index.module.scss';

import ogrodySrc from '../../assets/kpo/kpo-ogrody.webp';
import gogSrc from '../../assets/kpo/kpo-gog.webp';
import audiograSrc from '../../assets/kpo/kpo-audiogra.webp';
import { KPOBar } from "./kpo-bar";

export function KPOPage() {
    return <div>
        <KPOBar />
        <div className={css.list}>
            <div className={css.kpoItem}>
                <div className={css.image}>
                    <img src={gogSrc} alt="" />
                </div>
                <h3 className={css.title}>
                    GRA O GRACH. Showcase kompetencji i fabularnych innowacji
                </h3>
                <div className={css.intro}>
                    <p>
                        Projekt finansowany jest z funduszu unii Europejskiej NextGenerationEU w ramach programu Krajowy Plan Odbudowy.
                        Całkowita kwota wsparcia wyniosła 126 400,00 zł
                    </p>
                </div>
                <div className={css.text}>
                    <p>
                        Interaktywna gra online stworzona z myślą
                        o klientach i instytucjach, które chcą poznać potencjał gier w edukacji. promocji i integracji. Uczestnicy w przystępny sposób odkrywają mechaniki grywalizacji i sprawdzają.
                        jak możnaje zastosować w praktyce, jednocześnie eksplorując fabułę oraz podejmując decyzje wpływające na przebieg rozgrywki. Gra stanowi praktyczny showcase kompetencji zespołu oraz inspirację do
                        wdrażania nowoczesnych rozwiązań cyfrowych.
                    </p>
                </div>
                <div className={css.link}>
                    <a href="https://gog.alegranda.pl/" target="_black">https://gog.alegranda.pl/</a>
                </div>
            </div>

            <div className={`${css.kpoItem} ${css.reverse}`}>
                <div className={css.image}>
                    <img src={audiograSrc} alt="" />
                </div>
                <h3 className={css.title}>
                    Cyfrowa platforma do publikacji audiogier
                </h3>
                <div className={css.intro}>
                    <p>
                        Projekt finansowany jest z funduszu unii Europejskiej NextGenerationEU w ramach programu Krajowy Plan Odbudowy, całkowita kwota
                        wsparcia wyniosła 85 200,00 zł.
                    </p>
                </div>
                <div className={css.text}>
                    <p>
                        Innowacyjna platforma cyfrowa do publikacji i dystrybucji audiogier paragrafowych —
                        słuchowisk sterowanych decyzjami użyt-
                        kownika. Rozwiązanie wspiera edukację bez
                        ekranu, zwiększa dostępność dla osób z
                        dysfunkcjami wzroku i promuje nowoczesną narrację dźwiękową, Na platformie do-
                        stępne są trzy wzorcowe audiogry o tematyce kulturalno-muzycznej. pozwalające
                        użytkownikom rozwijać wiedzę i kreatywność. Projekt odpowiada na współczesne
                        wyzwania edukacji cyfrowej, łącząc innowacyjność z inkluzywnością.
                    </p>
                </div>
                <div className={css.link}>
                    <a href="https://audiogra.alegranda.pl/" target="_black">https://audiogra.alegranda.pl/</a>
                </div>
            </div>

            <div className={css.kpoItem}>
                <div className={css.image}>
                    <img src={ogrodySrc} alt="" />
                </div>
                <h3 className={css.title}>
                    Ekologiczne Ogrody Pokoleń
                </h3>
                <div className={css.intro}>
                    <p>
                        Projekt finansowany jest z funduszu unii Europejskiej NextGenerationElJ w ramach programu
                        Krajowy Plan Odbudowy. całkowita kwota
                        wsparcia wyniosła 109 600,00 ZŁ
                    </p>
                    <p>
                        Partnerem projektu jest Muzeum Pałacu Króla
                        Jana III w Wilanowie.
                    </p>
                </div>
                <div className={css.text}>
                    <p>
                        Innowacyjny kurs online dla pracowników
                        instytucji kultury. pokazujący. jak tworzyć
                        ekologiczne ogrody we współpracy z seniorami-ekspertami, Program obejmuje zagadnienia z permakultury, bioróżnorodności,
                        etnobotaniki i zrównoważonego ogrodnictwa, łącząc nowoczesne rozwiązania z tradycyjnymi praktykami. Kurs promuje międzypokoleniowy transfer wiedzy, inspirując
                        do wspólnego działania i tworzenia przestrzeni przyjaznych ludziom i środowisku.
                    </p>
                </div>
                <div className={css.link}>
                    <a href="https://ogrody.alegranda.pl/" target="_black">https://ogrody.alegranda.pl/</a>
                </div>
            </div>
        </div>

        <Logos />
        <LegalLinks />
    </div>
}
